/**
 * @generated SignedSource<<2d83aa98ef1e5517ebd1c74c3279c577>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LinkAccountQuery$variables = {
  token: string;
};
export type LinkAccountQuery$data = {
  readonly oauthLinkActivation: {
    readonly email: string | null;
    readonly oauthProvider: {
      readonly email: string;
      readonly provider: string;
    };
  } | null;
};
export type LinkAccountQuery = {
  response: LinkAccountQuery$data;
  variables: LinkAccountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkAccountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkAccountQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OauthLinkActivation",
        "kind": "LinkedField",
        "name": "oauthLinkActivation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OauthProvider",
            "kind": "LinkedField",
            "name": "oauthProvider",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90499ac54e9c84da61917e7d6978c453",
    "id": null,
    "metadata": {},
    "name": "LinkAccountQuery",
    "operationKind": "query",
    "text": "query LinkAccountQuery(\n  $token: String!\n) {\n  oauthLinkActivation(token: $token) {\n    email\n    oauthProvider {\n      email\n      provider\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e4763060f5dca66ede9e37c819ac684";

export default node;
